<template>
  <div class="site-footer-shell">
    <home-footer @license="openLicense" />
  </div>
</template>

<script>
import HomeFooter from './HomeFooter.vue'

export default {
  name: 'SiteFooter',
  components: { HomeFooter },
  methods: {
    openLicense () {
      if (this.$listeners.license) return this.$emit('license')
      return this.$router.push('/license')
    }
  }
}
</script>

<style scoped>
.site-footer-shell { flex: 0 0 auto; margin-top: auto; }
@media (max-width: 768px) {
  .site-footer-shell { padding-bottom: calc(58px + env(safe-area-inset-bottom)); background: #19192b; }
}
</style>
